import { useAtomValue, useSetAtom } from 'jotai';
import { sidePanelAtomDispatch } from '../../../../image/labelling-v2/atoms/side-panel-atoms';
import { selectedAnnotationIdsAtom } from '../../../../image/labelling-v2/atoms/tool-atoms';
import { useSidePanel } from '../../../side-panel/side-panel-provider';
export function useVisibilityMode() {
  const {
    visibilityModeAtom
  } = useSidePanel();
  const visibilityMode = useAtomValue(visibilityModeAtom);
  const selectedAnnotationIds = useAtomValue(selectedAnnotationIdsAtom);
  const setSelectedAnnotationIds = useSetAtom(selectedAnnotationIdsAtom);
  const dispatchVisibility = useSetAtom(sidePanelAtomDispatch);
  const isShowAll = visibilityMode.type === 'show-all';
  const activeLabelOnly = visibilityMode.type === 'label-only' ? visibilityMode.label : null;
  const toggleShowAll = () => {
    dispatchVisibility({
      type: 'TOGGLE_SHOW_ALL'
    });
  };
  const toggleLabelOnly = (label: string) => {
    if (selectedAnnotationIds.length > 0) {
      setSelectedAnnotationIds([]);
      dispatchVisibility({
        type: 'RESET_VISIBILITY'
      });
    }
    dispatchVisibility({
      type: 'TOGGLE_LABEL_ONLY',
      label
    });
  };
  return {
    visibilityMode,
    isShowAll,
    activeLabelOnly,
    toggleShowAll,
    toggleLabelOnly
  };
}